import { render, staticRenderFns } from "./zatca-phase-2.vue?vue&type=template&id=2874b8f2&scoped=true"
import script from "./zatca-phase-2.vue?vue&type=script&lang=js"
export * from "./zatca-phase-2.vue?vue&type=script&lang=js"
import style0 from "./zatca-phase-2.vue?vue&type=style&index=0&id=2874b8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874b8f2",
  null
  
)

export default component.exports